/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  CartItem,
  CartItemFromJSON,
  CartItemFromJSONTyped,
  CartItemToJSON,
} from './';

/**
 *
 * @export
 * @interface CartItemResponse
 */
export interface CartItemResponse {
  /**
   *
   * @type {string}
   * @memberof CartItemResponse
   */
  message: string;
  /**
   *
   * @type {CartItem}
   * @memberof CartItemResponse
   */
  item: CartItem;
}

export function CartItemResponseFromJSON(json: any): CartItemResponse {
  return CartItemResponseFromJSONTyped(json, false);
}

export function CartItemResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CartItemResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    message: json['message'],
    item: CartItemFromJSON(json['item']),
  };
}

export function CartItemResponseToJSON(value?: CartItemResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    message: value.message,
    item: CartItemToJSON(value.item),
  };
}
